import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule, AuthService } from '@auth0/auth0-angular';
import { AuthInterceptor } from '../models/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { environment } from '@trovata/environments/environment';
import { ENVIRONMENT_TOKEN, STORE_TOKEN } from '../models/config.model';
import { ConfigService } from '../services/config.service';

// @dynamic
@NgModule({
	imports: [
		CommonModule,
		AuthModule.forRoot({
			domain: environment.auth0Domain,
			cacheLocation: 'localstorage',
			clientId: environment.auth0ClientId,
			useRefreshTokens: true,
			authorizationParams: {
				audience: environment.auth0Audience,
				redirect_uri: window.location.origin,
				scope: environment.auth0Scope,
			},
			// The `code` and `state` parameters at `/home/connections/success` are from OAuth integraitons
			// with banking institutions and should not be intercepted by Auth0.
			// See https://auth0.github.io/auth0-angular/interfaces/AuthConfig.html#skipRedirectCallback
			skipRedirectCallback: window.location.pathname === '/home/connections/success',
		}),
	],
	providers: [
		AuthService,
		ConfigService,
		{
			provide: ENVIRONMENT_TOKEN,
			useValue: environment,
		},
		{
			provide: STORE_TOKEN,
			useValue: Store,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
	],
})
export class AuthenticationModule {}
